import { useId } from "react";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";

import { FormErrorMessage, FormItem, FormLabel } from "../../../_base/form";
import { CheckboxGroupField } from "../check-box-group";

import type { CheckboxGroupFieldProps } from "../check-box-group";

type Props = {
	accordionLabel: string;
	checkBoxGroupProps: CheckboxGroupFieldProps;

	errorMessage?: string;
	label?: string;
};

export const CheckboxGroupWithAccordionField = ({
	accordionLabel,
	checkBoxGroupProps,
	errorMessage,
	label,
}: Props): JSX.Element | null => {
	const uniqueId = useId();

	return (
		<FormItem>
			<FormLabel>{label}</FormLabel>
			<Accordion type={"single"} collapsible>
				<AccordionItem value={uniqueId}>
					<AccordionTrigger>
						<p className="mb-3 block">{accordionLabel}</p>
					</AccordionTrigger>
					<AccordionContent>
						<CheckboxGroupField {...checkBoxGroupProps} />
					</AccordionContent>
				</AccordionItem>
			</Accordion>
			<FormErrorMessage>{errorMessage}</FormErrorMessage>
		</FormItem>
	);
};
